import { mapState } from 'vuex'
import WuJieVue from 'wujie-vue2'
const { bus } = WuJieVue
export const message = {
  computed: {
    ...mapState('theme', ['curTheme'])
  },
  watch: {
    curTheme() {
      bus.$emit('changeCurTheme', this.curTheme)
    },
    token() {
      bus.$emit('changeToken', this.token)
    }
  }
}
